import * as React from 'react';
import { ErrorBoundary } from '../../utilities/global-error-boundary';

import { ILxsWelcomeData } from './lxs-welcome.data';
import { ILxsWelcomeProps } from './lxs-welcome.props.autogenerated';

export interface ILxsWelcomeViewProps extends ILxsWelcomeProps<ILxsWelcomeData> {}

/**
 *
 * LxsWelcome component
 * @extends {React.PureComponent<ILxsWelcomeProps<ILxsWelcomeData>>}
 */
class LxsWelcome extends React.PureComponent<ILxsWelcomeProps<ILxsWelcomeData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default ErrorBoundary(LxsWelcome, 'lxs-welcome');
